import { create } from 'zustand'

/**
 * Cross-surface state for the shared Update detail modal. The hub, timeline,
 * bell dropdown, and critical banner all call `open(id)`; a single
 * <AnnouncementDetailModalHost/> mounted in the AppShell renders the modal.
 */
interface AnnouncementModalState {
  openId: string | null
  open: (id: string) => void
  close: () => void
}

export const useAnnouncementModalStore = create<AnnouncementModalState>((set) => ({
  openId: null,
  open: (id) => set({ openId: id }),
  close: () => set({ openId: null }),
}))
